import { obDefaultValGet } from '../common/common';

export default class BoardField {
    constructor(initOb=null) {
        this.id = obDefaultValGet(initOb, 'id', ''); 
        this.num = obDefaultValGet(initOb, 'num', 0);
        this.active = obDefaultValGet(initOb, 'active', true);
        this.players = [];
        if (initOb !== null) {
            if ('players' in initOb) {
                this.players = [...initOb.players];                
            }            
        }
    }

    get isActive() {
        return this.active;
    }

    isPlayerSelected(userId) {
        return this.players.includes(userId);
    }
}